import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router-dom';

import { AuthProvider } from '@/auth/AuthProvider';
import { ErrorBoundary } from '@/components/primitives/ErrorBoundary';
import { queryClient } from '@/lib/query-client';
import { router } from '@/routes/router';

/**
 * Provider stack, outermost first:
 *   ErrorBoundary  — catches anything the router cannot
 *   QueryClient    — the single client (staleTime 30s, retry 1, no focus refetch)
 *   AuthProvider   — one Context, no store (CONVENTIONS.md §4.4)
 *   RouterProvider — the nested route tree
 */
export function App() {
  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <RouterProvider router={router} />
        </AuthProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  );
}
